import { DownloadsTable } from "@/components/downloads/downloads-table";
import { createFileRoute } from "@tanstack/react-router";

function DownloadsPage() {
  return <DownloadsTable />;
}

export const Route = createFileRoute("/_authenticated/website/downloads/")({
  component: DownloadsPage,
});
